import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'
import {
  CreateMotoristaImpedimentoModel,
  SearchMotoristaImpedimentoModel,
} from '../../../models/motorista-impedimento.model'

@Injectable({
  providedIn: 'root',
})
export class MotoristaImpedimentoService {
  private baseUrl = environment.baseUrl
  private resource = 'MotoristaImpedimento'

  constructor(private httpClient: HttpClient) {}

  public listByMotorista(motoristaId: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/motorista/${motoristaId}`,
    )
  }

  public search(filtro: SearchMotoristaImpedimentoModel): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search`,
      filtro,
    )
  }

  public create(
    model: CreateMotoristaImpedimentoModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create`,
      model,
    )
  }

  public delete(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.delete<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${id}`,
    )
  }
}
